module.exports = __webpack_public_path__ + "static/media/order-now-hover.b3d9c3d7.png";